(function() {
'use strict';

(function($) {
    const Trppopup = function(element, options) {
        this.init('trppopup', element, options);
    };

    Trppopup.prototype = {
        constructor: Trppopup,

        init(type, element, options) {
            // initialise
            this.type = type;
            this.$el = $(element);

            this.options = $.extend({}, $.fn[this.type].defaults, options);

            this.$popup = null; // (created on first "show')

            // listen to appropriate trigger events
            switch (this.options.trigger) {
                case 'click':
                    // toggle popup on click of target element
                    this.$el.on(`click.${this.type}`, $.proxy(this.toggle, this));
                    break;
                case 'hover':
                    this.$el.on(`mouseenter.${this.type}`, $.proxy(this.enter, this));
                    this.$el.on(`mouseleave.${this.type}`, $.proxy(this.hide, this));
                    break;
                case 'focus':
                    // for use with input fields
                    this.$el.on(`focus.${this.type}`, $.proxy(this.enter, this));

                    if (this.options.hideOnBlur) {
                        this.$el.on(`blur.${this.type}`, $.proxy(this.hide, this));
                    }

                    // close on tab out
                    this.$el.on(`keydown.${this.type}`, $.proxy(this.checkKeydown, this));

                    // close on external click
                    $('html').on(`mousedown.${this.type}`, $.proxy(this.checkClick, this));

                    break;
                case 'blur':
                    this.hide();
                    break;
                case 'manual':
                    // hide and show must be triggered manually
                    break;
            }
        },

        enter() { this.show(true); },
        leave() { this.hide(); },
        toggle() {
            if (this.open) {
                this.hide();
            } else {
                this.show(true);
            }
        },

        checkClick(e) {
            const $target = $(e.target);

            if (this.$popup && this.open) {
                // close popup on external click
                if ($target[0] !== this.$popup && this.$popup.find('*').index($target[0]) === -1) {
                    this.hide();
                }
            } else if (this.$popup && !this.open && $target.index(this.$el) >= 0) {
                this.show(true);
            }
        },

        checkKeydown(e) {
            const key = e.keyCode || e.which;
            // close if user tabs out
            if (key === 9) {
                this.hide();
            }
        },

        show(animate) {
            if (this.open) {
                return;
            }

            const $popup = this.popup();

            this.setContent();

            // we need to show the panel to get position
            $popup.show().css({ opacity: 0 });

            let options = {};

            switch (this.options.placement) {
                case 'top':
                    options = {
                        my: 'center bottom',
                        of: this.$el,
                        at: 'center top-10',
                        collision: 'none'
                    };
                    break;
                case 'bottom':
                    options = {
                        my: 'center top',
                        of: this.$el,
                        at: 'center bottom+10',
                        collision: 'none'
                    };
                    break;
                case 'left':
                    options = {
                        my: 'right center',
                        of: this.$el,
                        at: 'left-15 center',
                        collision: 'none'
                    };
                    break;
                case 'right':
                    options = {
                        my: 'left center',
                        of: this.$el,
                        at: 'right+15 center',
                        collision: 'none'
                    };
                    break;
            }

            $popup.position(options);

            if (animate) {
                $popup.animate({ opacity: 1 }, 150);
            } else {
                $popup.css({ opacity: 1 });
            }
            this.open = true;
        },

        hide() {
            if (!this.open) {
                return;
            }

            const self = this;
            const _popup = this.$popup;

            _popup.animate({ opacity: 0 }, 150, function() {
                _popup.hide();
                self.open = false;
                self.destroy();
            });
        },

        getPosition() {
            return $.extend({}, (this.$el.offset()), {
                width: this.$el[0].offsetWidth,
                height: this.$el[0].offsetHeight
            });
        },

        setContent() {
            const $popup = this.popup();
            const content = this.getContent();

            $popup.find('.content')[this.options.html ? 'html' : 'text'](content);
        },

        getContent() {
            // content can be a string or a function
            return typeof this.options.content === 'function' ? this.options.content.call(this.$el[0]) : this.options.content;
        },

        popup() {
            // create element if it does not exist
            if (!this.$popup) {
                this.$popup = $(this.options.popupTemplate)
                    .addClass(this.options.placement);

                if (this.options.variant) {
                    this.$popup.addClass(this.options.variant);
                }

                if (this.options.width) {
                    this.$popup.css('width', this.options.width);
                }

                //this.$popup.insertAfter(this.$el);
                this.$popup.appendTo(document.body);
            }

            return this.$popup;
        },

        destroy() {
            //this.hide();

            switch (this.options.trigger) {
                case 'click':
                    // toggle popup on click of target element
                    this.$el.off(`click.${this.type}`);
                    break;
                case 'hover':
                    this.$el.off(`mouseenter.${this.type}`);
                    this.$el.off(`mouseleave.${this.type}`);
                    break;
                case 'focus':
                    // for use with input fields
                    this.$el.off(`focus.${this.type}`);
                    this.$el.off(`blur.${this.type}`);
                    // close on tab out
                    this.$el.off(`keydown.${this.type}`);
                    // close on external click
                    $('html').off(`mousedown.${this.type}`);
                    break;
            }

            this.$el.data('trppopup', null);

            //DK quick fix to stop our logs filling up
            if (this.$popup != null) {
                this.$popup.remove();
                this.$popup = null;
            }
        }
    };

    /* trppopup PLUGIN DEFINITION
    * ========================= */

    $.fn.trppopup = function(option) {
        return this.each(function() {
            const $this = $(this);
            const options = typeof option === 'object' && option;
            let data = $this.data('trppopup');
            if (!data) {
                $this.data('trppopup', (data = new Trppopup(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
    };

    $.fn.trppopup.Constructor = Trppopup;

    $.fn.trppopup.defaults = {
        trigger: 'focus',
        placement: 'bottom',
        popupTemplate: '<div class="popup"><div class="arrow"></div><div class="content"></div></div>',
        variant: '', // , e.g. 'error'
        content: '',
        html: true, // < is content html?,
        width: null,
        hideOnBlur: false
    };
})(jQuery);
})();
